import clsx from "clsx";

interface Props {
  page: number;
  pages: number;
  total: number;
  onChange: (page: number) => void;
}

export function Pagination({ page, pages, total, onChange }: Props) {
  const canPrev = page > 1;
  const canNext = page < pages;
  return (
    <div className="flex items-center justify-between gap-3 text-sm">
      <div className="text-slate-600">
        Page <span className="font-medium">{page}</span> /{" "}
        <span className="font-medium">{Math.max(pages, 1)}</span>{" "}
        <span className="text-slate-400">·</span>{" "}
        <span className="font-medium">{total.toLocaleString("en-US")}</span>{" "}
        rows
      </div>
      <div className="flex items-center gap-1">
        <button
          type="button"
          className={clsx("btn-secondary", !canPrev && "opacity-50")}
          disabled={!canPrev}
          onClick={() => onChange(1)}
        >
          «
        </button>
        <button
          type="button"
          className={clsx("btn-secondary", !canPrev && "opacity-50")}
          disabled={!canPrev}
          onClick={() => onChange(page - 1)}
        >
          ‹ Prev
        </button>
        <button
          type="button"
          className={clsx("btn-secondary", !canNext && "opacity-50")}
          disabled={!canNext}
          onClick={() => onChange(page + 1)}
        >
          Next ›
        </button>
        <button
          type="button"
          className={clsx("btn-secondary", !canNext && "opacity-50")}
          disabled={!canNext}
          onClick={() => onChange(pages)}
        >
          »
        </button>
      </div>
    </div>
  );
}
